import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";

function Signin() {
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const response = await fetch(`${baseurl}/login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            console.log(data);

            if (response.ok) {
                toast.success("Login successful!");
                sessionStorage.setItem('authToken', data.token);
                window.location.href = "/"; // Redirect to dashboard
            } else {
                toast.error(data.message || "Invalid credentials");
            }
        } catch (error) {
            toast.error("Something went wrong! Please try again.");
        }

        setLoading(false);
    };

    return (
        <>
            <div className="container-fluid custom-page">
                <div className="row bg-white">
                    {/* The image half */}
                    <div className="col-md-6 col-lg-6 col-xl-7 d-none d-md-flex bg-primary-transparent-3">
                        <div className="row w-100 mx-auto text-center">
                            <div className="col-md-12 col-lg-12 col-xl-12 my-auto mx-auto w-100">
                                <img src="assets/images/backgroud/loginImage.png"
                                    className="my-auto ht-xl-80p wd-md-100p wd-xl-80p mx-auto" alt="logo"/>
                            </div>
                        </div>
                    </div>

                    {/* The content half */}
                    <div className="col-md-6 col-lg-6 col-xl-5 bg-white py-4">
                        <div className="login d-flex align-items-center py-2">
                            <div className="container p-0">
                                <div className="row">
                                    <div className="col-md-10 col-lg-10 col-xl-9 mx-auto">
                                        <div className="card-sigin">
                                            <div className="card-sigin">
                                                <div className="main-signup-header">
                                                    <h3>Welcome back!</h3>
                                                    <h6 className="fw-medium mb-4 fs-17">Please sign in to continue.</h6>
                                                    
                                                    {error && <p className="text-danger">{error}</p>}
                                                    
                                                    <form onSubmit={handleLogin}>
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">Email</label>
                                                            <input 
                                                                className="form-control"
                                                                placeholder="Enter your email"
                                                                type="email"
                                                                value={email}
                                                                onChange={(e) => setEmail(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="form-group mb-3">
                                                            <label className="form-label">Password</label>
                                                            <input 
                                                                className="form-control"
                                                                placeholder="Enter your password"
                                                                type="password"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <button type="submit" className="btn btn-primary btn-block w-100" disabled={loading}>
                                                            {loading ? "Signing in..." : "Sign In"}
                                                        </button>
                                                    </form>

                                                    <div className="main-signin-footer mt-5">
                                                        <p className="mb-1"><a href="/Forgot">Forgot password?</a></p>
                                                        <p>Don't have an account? <a href="/Signup">Create an Account</a></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End */}
                            </div>
                        </div>
                        {/* End */}
                    </div>
                </div>
            </div>
            <ToastContainer/>
        </>
    );
}

export default Signin;
